import React from 'react';
import { t } from '../../../../../../modules/infra/i18n';

const TableHeader = () => (
  <div className="c-appointment-details-head">
    <div className="c-appointment-details-head__col">
      <span className="c-appointment-details__heading">{t('appointment:list.table_header.number')}</span>
    </div>
    <div className="c-appointment-details-head__col">
      <span className="large-and-up-p--">
        <span className="c-appointment-details__heading">{t('appointment:list.table_header.service_time')}</span>
      </span>
    </div>
    <div className="c-appointment-details-head__col">
      <span className="c-appointment-details__heading">{t('appointment:list.table_header.client_name')}</span>
    </div>
    <div className="c-appointment-details-head__col">
      <span className="c-appointment-details__heading">{t('appointment:list.table_header.service_type')}</span>
    </div>
    <div className="c-appointment-details-head__col">
      <span className="c-appointment-details__heading">{t('appointment:list.table_header.barber_name')}</span>
    </div>
    <div className="c-appointment-details-head__col">
      <span className="c-appointment-details__heading">{t('appointment:list.table_header.status')}</span>
    </div>
  </div>
);

export default TableHeader;
